import {
  Grid,
  TextField,
  Button,
  Box,
  InputLabel,
  Autocomplete,
  Select,
  MenuItem,
  FormControl,
} from "@mui/material";
import ArrowForward from "@mui/icons-material/ArrowForward";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { useNotification } from "../../../../../Hooks/useNotification";

const FilterItems = ({
  filterData,
  handleChangeFilter,
  handleFilter,
  handleClearFilters,
  bays,
  categories,
  groups,
}) => {
  const showNotification = useNotification();

  return (
    <Grid container spacing={3}>
      {/* Bays Autocomplete Filter (Multi-select) */}
      <Grid item xs={12} md={4}>
        <InputLabel sx={{ fontSize: "14px", marginBottom: "5px" }}>
          Bays
        </InputLabel>
        <Autocomplete
          multiple
          disablePortal
          options={bays}
          getOptionLabel={(option) => option.bay_code}
          value={
            filterData.bay_code
              ? bays.filter((b) => filterData.bay_code.includes(b.bay_code))
              : []
          }
          onChange={(_, newValue) => {
            const bayCodes = newValue.map((item) => item.bay_code);
            handleChangeFilter("bay_code")(null, bayCodes);
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              variant="outlined"
              placeholder="Select Bays"
            />
          )}
        />
      </Grid>

      <Grid item xs={12} md={4}>
        <InputLabel sx={{ fontSize: "14px", marginBottom: "5px" }}>
          Start Date
        </InputLabel>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            value={filterData.start_date}
            onChange={(newValue) =>
              handleChangeFilter("start_date")(null, newValue)
            }
            format="DD/MM/YYYY"
            sx={{ width: "100%" }}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                fullWidth
                onKeyDown={(e) => {
                  if (e.key === "Enter") handleFilter();
                }}
              />
            )}
          />
        </LocalizationProvider>
      </Grid>

      <Grid item xs={12} md={4}>
        <InputLabel sx={{ fontSize: "14px", marginBottom: "5px" }}>
          End Date
        </InputLabel>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            value={filterData.end_date}
            onChange={(newValue) =>
              handleChangeFilter("end_date")(null, newValue)
            }
            format="DD/MM/YYYY"
            sx={{ width: "100%" }}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                fullWidth
                onKeyDown={(e) => {
                  if (e.key === "Enter") handleFilter();
                }}
              />
            )}
          />
        </LocalizationProvider>
      </Grid>

      {/* Group By Select Filter */}
      <Grid item xs={12} md={4}>
        <InputLabel sx={{ fontSize: "14px", marginBottom: "5px" }}>
          Group By
        </InputLabel>
        <FormControl fullWidth>
          <Select
            value={filterData.group_by || ""}
            onChange={(e) => {
              const newGroupBy = e.target.value;
              // Clear category_code if changing from category to something else
              if (
                filterData.group_by === "category" &&
                newGroupBy !== "category"
              ) {
                handleChangeFilter("category_code")(null, []);
              }
              handleChangeFilter("group_by")(null, newGroupBy);
            }}
            displayEmpty
            variant="outlined"
          >
            <MenuItem value="">
              <em>None</em>
            </MenuItem>
            {groups.map((group) => (
              <MenuItem key={group.group_code} value={group.group_code}>
                {group.group_name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>

      {/* Category Autocomplete Filter (Multi-select) - Only show when Group By is "category" */}
      {filterData.group_by === "category" && (
        <Grid item xs={12} md={4}>
          <InputLabel sx={{ fontSize: "14px", marginBottom: "5px" }}>
            Category
          </InputLabel>
          <Autocomplete
            multiple
            disablePortal
            options={categories}
            getOptionLabel={(option) =>
              `${option.category_code} - ${option.category_name}`
            }
            value={
              filterData.category_code
                ? categories.filter((c) =>
                    filterData.category_code.includes(c.category_code)
                  )
                : []
            }
            onChange={(_, newValue) => {
              const categoryCodes = newValue.map((item) => item.category_code);
              handleChangeFilter("category_code")(null, categoryCodes);
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                placeholder="Select Categories"
              />
            )}
          />
        </Grid>
      )}

      {/* Action Buttons */}
      <Grid item xs={12}>
        <Box textAlign="right">
          <Button
            variant="outlined"
            onClick={handleClearFilters}
            sx={{ mr: 1, color: "#7152F3" }}
          >
            Clear
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              if (
                filterData.group_by === "category" &&
                (!filterData.category_code ||
                  filterData.category_code.length === 0)
              ) {
                showNotification(
                  "error",
                  "Please select at least one category."
                );
                return;
              }
              handleFilter();
            }}
            sx={{ backgroundColor: "#7152F3" }}
          >
            Filter{" "}
            <ArrowForward fontSize="small" style={{ marginLeft: "5px" }} />
          </Button>
        </Box>
      </Grid>
    </Grid>
  );
};

export default FilterItems;
